import { render, staticRenderFns } from "./Consumptions copy.vue?vue&type=template&id=60bc275b"
import script from "./Consumptions copy.vue?vue&type=script&lang=js"
export * from "./Consumptions copy.vue?vue&type=script&lang=js"
import style0 from "./Consumptions copy.vue?vue&type=style&index=0&id=60bc275b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports